'use client'

import styles from 'pagestyles/article.module.scss'
import { Button } from 'components/Phantom/Button'

const showAppButton = (slug: string) => {
	return slug === 'the-all-new-eight-sleep-app-is-simpler-easier-and-more-powerful-than-ever'
}

export const AppButton = (props: { slug: string }) => {
	if (showAppButton(props.slug)) {
		return (
			<div className={`outer-margins-y inner-paddings-x ${styles.button_container}`}>
				<Button.Dark
					id={'app_cta'}
					href="https://eight.app.link/e/app"
				>
					Get the latest app
				</Button.Dark>
			</div>
		)
	}

	return null
}
